import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["__scopeDialog"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { TRIGGER_NAME } from './constants';
import { useDialogContext } from './context';
import { getDataStateValue } from './utils';
import { useComposedRefs } from '../../internal/hooks/useComposedRefs';
import { DomPrimitive } from '../../internal/components/DomPrimitive';
import { composeEventHandlers } from '../../internal/utils/composeEventHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
export var DialogTrigger = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var __scopeDialog = props.__scopeDialog,
    triggerProps = _objectWithoutProperties(props, _excluded);
  var context = useDialogContext(TRIGGER_NAME, __scopeDialog);
  var composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
  return /*#__PURE__*/_jsx(DomPrimitive.button, _objectSpread(_objectSpread({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": context.open,
    "aria-controls": context.contentId,
    "data-state": getDataStateValue(context.open)
  }, triggerProps), {}, {
    ref: composedTriggerRef,
    onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
  }));
});
DialogTrigger.displayName = TRIGGER_NAME;